var Freezer = require('./src/freezer');
module.exports = Freezer;


//////////////////
// WEBPACK FOOTER
// ../~/freezer-js/freezer.js
// module id = 559
// module chunks = 10